<template>
  <div class="mmap">
    <div class="mmap-inner">
      <div class="mmap-inner-search">
        <div class="title">Find a Retailer</div>
        <el-input placeholder="City, Postcode Country" v-model="search" @change="$router.push({path:'/map',query:{keyword:search}})"
          class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="$router.push({path:'/map',query:{keyword:search}})"></el-button>
        </el-input>
      </div>
      <img src="../../assets/mimages/component/thinkgrow_indoor-led_ios_map.png" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'footerbar',
    data() {
      return {
        search: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mmap {
    width: 100%;
    height: 2rem;

    &-inner {
      height: 100%;
      position: relative;

      &-search {
        position: absolute;
        left: 50%;
        top: 0;
        margin-left: -2.34rem;
        padding: 0.5rem 0;
        width: 4.68rem;
        text-align: center;

        .title {
          width: 100%;
          font-size: 0.38rem;
          font-weight: 600;
        }
        >>>.el-input__inner {
          height: 0.5rem;
          line-height: 0.5rem;
          font-size:0.2rem ;
        }
        >>>.el-button{
          padding: 0.1rem 0.08rem;
          font-size: 0.3rem;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
    .input-with-select{
       margin-top: 0.2rem;
    }

  }
</style>



// WEBPACK FOOTER //
// src/mlayout/component/Mapbar.vue